import { assoc, compose, pick } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useSaveIntegrations } from '../../_requests/saveIntegrations'
import Form from '../../../../../packages/kiti/components/form/form/Form'
import FormItem from '../../../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../../../packages/kiti/components/form/SubmitBar'

const cleanRequest = form => {
  return compose(
    pick(['id', 'service', 'name', 'token']),
    item => assoc('service', 'CHAT_PRO', item),
    item => assoc('token', `${item.instanceId}:${item.instanceToken}`, item)
  )(form)
}

const FormChatPro = ({ integrationId, moveBackOnSuccess, ...props }) => {
  const { t } = useTranslation('listIntegrations')
  const [save, { loading, error }] = useSaveIntegrations(cleanRequest, moveBackOnSuccess)

  return (
    <Form initialState={{ id: integrationId, service: 'chat_pro' }} onSubmit={save}>
      <FormItem label={t('chat_pro.name')} field="name" />
      <Separator weight={2} />
      <FormItem label={t('chat_pro.instanceId')} field="instanceId" />
      <Separator weight={2} />
      <FormItem label={t('chat_pro.instanceToken')} field="instanceToken" />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default FormChatPro
